import angularImage from 'assets/images/techs-logos/angular.svg'
import cssImage from 'assets/images/techs-logos/css3.svg'
import dataStructuresImage from 'assets/images/techs-logos/data-structures.png'
import htmlImage from 'assets/images/techs-logos/html.png'
import javaScriptImage from 'assets/images/techs-logos/javascript-thin.svg'
import nodejsImage from 'assets/images/techs-logos/nodejs.svg'
import reactImage from 'assets/images/techs-logos/react.svg'
import sqlImage from 'assets/images/techs-logos/sql.png'
import typescriptImage from 'assets/images/techs-logos/typescript.svg'
import techImagePlaceholder from 'assets/placeholders/exam-placeholder.svg'

export const getCardImage = (category: string) => {
  switch (category) {
    case 'JavaScript':
      return javaScriptImage
    case 'HTML':
      return htmlImage
    case 'TypeScript':
      return typescriptImage
    case 'React':
      return reactImage
    case 'Angular':
      return angularImage
    case 'Node.js':
      return nodejsImage
    case 'CSS':
      return cssImage
    case 'Computer Science':
      return dataStructuresImage
    case 'SQL':
      return sqlImage
    default:
      return techImagePlaceholder
  }
}
